var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProduct = function SvgProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA384D",
    fillRule: "evenodd",
    d: "M5.37 1.337a.583.583 0 1 0-.824.825L5.883 3.5H2.917a1.75 1.75 0 0 0-1.75 1.75v5.833c0 .967.783 1.75 1.75 1.75h8.166a1.75 1.75 0 0 0 1.75-1.75V5.25a1.75 1.75 0 0 0-1.75-1.75H8.117l1.337-1.338a.583.583 0 1 0-.825-.825L7 2.967l-1.63-1.63Zm-2.453 3.33h3.5v2.916H2.333V5.25c0-.322.261-.583.584-.583Zm4.666 2.916V4.667h3.5c.322 0 .584.26.584.583v2.333H7.583ZM2.333 8.75h4.084v2.917h-3.5a.583.583 0 0 1-.584-.584V8.75Zm5.25 0v2.917h3.5a.583.583 0 0 0 .584-.584V8.75H7.583Z",
    clipRule: "evenodd"
  })));
};
export default SvgProduct;